module.exports = __webpack_public_path__ + "media/images/sp/specials/common/bg-b57e7522dce73f4f72f841a6124776af.jpg";